//React imports
import React, { } from 'react';
import { useHistory } from 'react-router-dom';
//---

//CSS imports
import './ArtefactDetails.css'
//---

//PrimeReact imports
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { Panel } from 'primereact/panel';
import { Chip } from 'primereact/chip';
import { Divider } from 'primereact/divider';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
//---

//Vendors imports
//---

//Components imports
//---

//Utils imports
import { formatFullDate } from '../../utils/Date';
import { getFilename } from '../../utils/Regex';
//---

//Data requests imports
import { extractSecretName } from '../../data/SecretData';
//---

const ArtefactDetails = ({ artefact, projectName, deleteArtefact }) => {
    const history = useHistory();

    const onEdit = () => {
        history.push({
            pathname: '/' + projectName + '/artefact/update/' + artefact.name,
        })
    }

    const onDelete = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this artefact ?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => deleteArtefact(artefact.name),
        });
    }

    const getEnvVarValue = (env) => {
        if (env) {
            let sEnv = env.split('::')
            if (sEnv.length > 1) {
                let [, ...rest] = sEnv

                return rest.join('::')
            }
        }

        return env
    }

    const renderEnvironmentVar = (env) => {
        if (env.value.toString().startsWith('TYPE_STRING::data:application/json')) {
            return (
                <p key={env.name}><span className="p-text-bold">{env.name} : </span>{getFilename(env.value)}</p>
            )
        } else {
            return (
                <p key={env.name}><span className="p-text-bold">{env.name} : </span>{getEnvVarValue(env.value.toString())}</p>
            )
        }
    }

    const renderSecretChips = (secrets) => {
        if (secrets) {
            return secrets.map((id, i) => (
                <Chip
                    key={`${id}-${i}`}
                    label={extractSecretName(id)}
                    className="secret-chip"
                    onClick={() => {
                        history.push({
                            pathname: '/' + projectName + "/secrets",
                            search: '?selected-secret=' + id
                        })
                    }}
                />
            ));
        }

        return null;
    }

    const renderCustomImageWarning = (artefact) => {
        if (artefact?.kind !== 'custom' && artefact?.image !== '') {
            return (
                <p className='p-d-flex text-color-orange'>
                    <i className="pi pi-exclamation-circle p-mr-1"></i>
                    A custom image is specified - it will be used instead of the default image of the "{artefact.kind}" artifact type
                </p>
            );
        }


        return null;
    }

    return (
        <div className='artefact-details p-mb-2'>
            <ConfirmPopup />
            <Fieldset className='p-ml-0 p-mr-0 container' legend={artefact.name}>
                <h3 className='title-color'>Details</h3>
                <p><span className="p-text-bold">Name : </span>{artefact.name}</p>
                <p><span className="p-text-bold">Description : </span>{artefact.description}</p>
                <p><span className="p-text-bold">Kind : </span>{artefact.kind}</p>
                <p><span className="p-text-bold">Image : </span>{artefact.image}</p>
                {renderCustomImageWarning(artefact)}
                <p><span className="p-text-bold">Git URL : </span>{artefact['git-url']}</p>
                <p><span className="p-text-bold">Git branch : </span>{artefact['git-branch']}</p>
                <p><span className="p-text-bold">Code path : </span>{artefact['code-path']}</p>
                <p><span className="p-text-bold">Last modified : </span>{formatFullDate(artefact['last-modified-time'])}</p>
                <p><span className="p-text-bold">Created : </span>{formatFullDate(artefact['creation-time'])}</p>

                <Divider />

                <Panel className='p-mb-3 panel secret-chips-container' header="Secrets" toggleable collapsed>
                    {renderSecretChips(artefact.secrets)}
                </Panel>

                <Divider />

                <Panel className='p-mb-3 panel' header="Environment" toggleable collapsed>
                    {artefact.env ? artefact.env.map(env => renderEnvironmentVar(env)) : null}
                </Panel>

                <Divider />

                <Button
                    className='p-mr-2'
                    label='Edit' icon="pi pi-pencil" onClick={onEdit}
                />
                <Button
                    className="p-button-danger p-button-outlined p-mr-2"
                    label='Delete' icon="pi pi-times" onClick={onDelete}
                />
            </Fieldset>
        </div>
    );
};

export default ArtefactDetails;